<template>
  <div>
    <div
      v-if="images.length > 1"
      class="img-container"
    >
      <div v-if="!detail && !expanded_images">
        <img
          :src="images[0].url"
          class="img-fluid"
          alt
        >
        <div
          class="overlay"
          @click="light_box = true"
        >
          <div class="text">
            +{{ images.length - 1 }}
          </div>
        </div>
      </div>
      <div
        v-else
      >
        <div
          v-for="(image, imageIndex) in images"
          :key="`image${imageIndex}`"
          class="fixed-width"
        >
          <img
            :src="image.url"
            class="img-fluid"
            alt
            @click="light_box = true"
          >
        </div>
      </div>
    </div>
    <div v-else-if="images.length === 1">
      <img
        :src="images[0].url"
        class="img-fluid"
        alt
        @click="light_box = true"
      >
    </div>

    <div v-if="light_box">
      <light-box
        :media="media"
        @onClosed="light_box = false"
      />
    </div>
  </div>
</template>

<script>
import LightBox from 'vue-image-lightbox';

export default {
  name: 'Images',
  components: {
    LightBox,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    detail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded_images: false,
      light_box: false,
    };
  },
  computed: {
    media() {
      const media = [];
      this.images.forEach((img) => {
        media.push({
          thumb: img.url,
          src: img.url,
        });
      });

      return media;
    },
  },
};
</script>

<style lang="scss">
.fixed-width {
  width: 100%;
}

.img-container {
  cursor: pointer;
  position: relative;
  width: 100%;
}

.overlay {
  position: absolute;
  cursor: pointer;
  top: 0px;
  height: 100%;
  width: 100%;
  background: rgba(128, 128, 128, 0.445);

  .text {
    position: absolute;
    bottom: 15px;
    right: 15px;
    color: var(--gray-darkest);
    font-size: 3em;
  }
}
</style>
